// Central SEO configuration for JusticeVerse.
export const SITE_URL = "https://justice-verse.com";
export const SITE_NAME = "JusticeVerse";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;
export const LOGO_URL = `${SITE_URL}/logo.png`;
export const TWITTER_HANDLE = "@justiceverse";

export const DEFAULT_DESCRIPTION =
  "JusticeVerse is India's most advanced AI legal platform — AI legal research, legal drafting, case-brief analysis, document translation and judiciary exam preparation in 11+ Indian languages. Built for advocates, law students, judges and law firms.";

export const DEFAULT_KEYWORDS =
  "legal AI, AI legal research, AI legal drafting, AI case brief, legal document translation, judiciary exam preparation, best legal AI India, JusticeVerse, JusticeVerse AI, Indian law AI, most accurate legal AI";

// Pages included in the XML sitemap / internal-link graph.
export const SITEMAP_ROUTES = [
  { path: "/", priority: 1.0, changefreq: "daily" },
  { path: "/justicebot", priority: 0.9, changefreq: "weekly" },
  { path: "/counsel", priority: 0.9, changefreq: "weekly" },
  { path: "/casebrief", priority: 0.9, changefreq: "weekly" },
  { path: "/verse-translation", priority: 0.9, changefreq: "weekly" },
  { path: "/prepmate", priority: 0.9, changefreq: "weekly" },
  { path: "/knowledge-hub", priority: 0.7, changefreq: "daily" },
  { path: "/careers", priority: 0.7, changefreq: "daily" },
  { path: "/pricing", priority: 0.8, changefreq: "weekly" },
  // SEO landing pages
  { path: "/ai-legal-research", priority: 0.9, changefreq: "weekly" },
  { path: "/ai-legal-drafting", priority: 0.9, changefreq: "weekly" },
  { path: "/ai-case-brief", priority: 0.9, changefreq: "weekly" },
  { path: "/document-translation", priority: 0.9, changefreq: "weekly" },
  { path: "/document-analysis", priority: 0.9, changefreq: "weekly" },
  { path: "/judiciary-preparation", priority: 0.9, changefreq: "weekly" },
  { path: "/best-legal-ai-for-advocates", priority: 0.9, changefreq: "weekly" },
  { path: "/best-legal-ai-for-law-students", priority: 0.9, changefreq: "weekly" },
  { path: "/justiceverse-ai", priority: 1.0, changefreq: "weekly" },
  { path: "/best-indian-legal-ai", priority: 0.9, changefreq: "weekly" },
  { path: "/most-accurate-legal-ai", priority: 0.9, changefreq: "weekly" },
];

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  alternateName: ["Justice Verse", "JusticeVerse AI", "JusticeVerse Legal AI"],
  url: SITE_URL,
  logo: LOGO_URL,
  description: DEFAULT_DESCRIPTION,
  foundingDate: "2025",
  areaServed: "IN",
  knowsLanguage: ["en", "hi", "gu", "mr", "ta", "te", "bn", "kn", "pa", "ml", "ur"],
  sameAs: [],
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  alternateName: "Justice Verse",
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/knowledge-hub?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const softwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: SITE_NAME,
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: SITE_URL,
  description: DEFAULT_DESCRIPTION,
  offers: {
    "@type": "Offer",
    price: "29",
    priceCurrency: "INR",
    description: "Plans from ₹29/month for students, advocates, clients and law firms.",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    ratingCount: "184",
  },
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const productSchema = (name, description, price) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name,
  description,
  brand: { "@type": "Brand", name: SITE_NAME },
  offers: {
    "@type": "Offer",
    price: String(price),
    priceCurrency: "INR",
    availability: "https://schema.org/InStock",
    url: SITE_URL,
  },
});
